import Model from "../../Model.js";

/**
 * `DocumentNotificationDefinition` defines a notification for a given selection of documents.
 *
 * @param {string[]} spec.recipients - List of usernames where we want to send the notification
 * @param {string} spec.folderId - id of the folder where we want end user to end up when he uses link in the notification
 */
export default class DocumentNotificationDefinition extends Model {
	constructor({ recipients, folderId, setting } = {}) {
		super(...arguments);
		this._recipients = recipients;
		this._folderId = folderId;
		this._setting = setting;
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.recipients = this._recipients;
		properties.folderId = this._folderId;
		properties.setting = this._setting;

		return properties;
	}
}
